import type { TranslationKey } from '../i18n';

export type ShopCategory = 'styling' | 'haircare' | 'beard' | 'aftershave' | 'hair';

export interface ShopProduct {
  id: string;
  category: ShopCategory;
  name: string;
  brand: string;
  subtitle?: string;
  description: string;
  shortDescription: string;
  variants: Array<{ volume: string | null; price: number }>;
  priceFrom: number;
  tags: string[];
  image: string;
  isNew?: boolean;
  aiContext?: string;
}

type Translate = (key: TranslationKey) => string;

export const getShopProducts = (t: Translate): ShopProduct[] => [
  {
    id: 'morgans-beard-shampoo', category: 'beard', name: t('productBeardShampooName'), brand: "MORGAN'S",
    description: t('productBeardShampooDescription'), shortDescription: t('productBeardShampooDescription'),
    variants: [{ volume: '100 ml', price: 2200 }], priceFrom: 2200, tags: [t('productBeardShampooTag1'), t('productBeardShampooTag2')], image: '/products/white/shampoo-100.png', aiContext: 'beard shampoo, cleansing, moisturising, soft beard, Morgan’s, beard care',
  },
  {
    id: 'morgans-beard-mustache-cream', category: 'beard', name: t('productBeardCreamName'), brand: "MORGAN'S",
    description: t('productBeardCreamDescription'), shortDescription: t('productBeardCreamDescription'),
    variants: [{ volume: '75 ml', price: 1700 }], priceFrom: 1700, tags: [t('productBeardCreamTag1'), t('productBeardCreamTag2')], image: '/products/white/beard-balm.jpg', aiContext: 'beard cream, moustache cream, moisturising, nourishing, Morgan’s, beard care',
  },
  {
    id: 'davines-energizing-shampoo', category: 'hair', name: t('productEnergizingName'), brand: 'Davines Naturaltech',
    description: t('productEnergizingDescription'), shortDescription: t('productEnergizingDescription'),
    variants: [{ volume: '250 ml', price: 3300 }], priceFrom: 3300, tags: [t('productEnergizingTag1'), t('productEnergizingTag2')], image: '/products/white/shampoo-250.png', aiContext: 'energising shampoo, Davines Naturaltech, scalp care, hair care',
  },
  {
    id: 'davines-anti-dandruff-shampoo', category: 'hair', name: t('productPurifyingName'), brand: 'Davines Naturaltech',
    description: t('productPurifyingDescription'), shortDescription: t('productPurifyingDescription'),
    variants: [{ volume: '250 ml', price: 3300 }], priceFrom: 3300, tags: [t('productPurifyingTag1'), t('productPurifyingTag2')], image: '/products/white/shampoo-250.png', aiContext: 'purifying shampoo, anti-dandruff, Davines Naturaltech, scalp care',
  },
  {
    id: 'davines-solu-shampoo', category: 'hair', name: t('productSoluName'), brand: 'Davines',
    description: t('productSoluDescription'), shortDescription: t('productSoluDescription'),
    variants: [{ volume: '250 ml', price: 2200 }], priceFrom: 2200, tags: [t('productSoluTag1'), t('productSoluTag2')], image: '/products/white/shampoo-250.png', aiContext: 'cleansing shampoo, Davines SOLU, deep cleansing, styling residue, hair care',
  },
  {
    id: 'proraso-shaving-soap', category: 'aftershave', name: t('productShavingSoapName'), brand: 'PRORASO',
    description: t('productShavingSoapDescription'), shortDescription: t('productShavingSoapDescription'),
    variants: [{ volume: '150 ml', price: 750 }], priceFrom: 750, tags: [t('productShavingSoapTag1'), t('productShavingSoapTag2')], image: '/products/white/aftershave-lotion.jpg', aiContext: 'shaving soap, Proraso, fresh shave, beard care',
  },
];
